import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
    AppMountAction,
    GetAgencyAction,
    FetchDashboardDataAction,
    CreateFilesAgencyAction,
    UpdateAgencyAction,
} from 'src/store/actions/app-actions';
import { AppActions } from '../constants';
import {
    failureType,
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
} from 'src/services/api-handlers/api-resolver';
import { convertValuesToFormData } from '../../components/redux-form/utils/values-to-form-data';
import { AppApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from 'src/services/api-handlers/pagination';
import sortingService from 'src/services/sorting';
import { groupInfo } from 'src/helpers/agencyInfo';

import { SubmissionError } from 'redux-form';
import { makeFormErrors } from '../../components/redux-form/utils/make-form-errors';
import { getProfile } from '../actions/auth-actions';
import user from '../../services/user-auth';
import UserRole from '../../enumerables/user-role';
import { toast } from 'react-toastify';
import { getAgency } from '../actions/app-actions';

function* handleAppMount(action: AppMountAction) {
    const {
        payload: { id },
    } = action;

    yield resolveApiCall(action, async () => AppApi.getEnums(id));

    yield put(getAgency({ page: 1, itemsPerPage: 1200 }));

    if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
        yield put(getProfile());
    } else if (user.getRoles().includes(UserRole.ROLE_USER)) {
        yield put(getProfile());
    }
}
function* handleFetchDashBoard(action: FetchDashboardDataAction) {
    const { payload, type } = action;

    yield resolveApiCall(
        action,
        () => AppApi.fetchDashBoard(),
        function* (data: ResolverApiSuccess) {
            yield put({
                type: failureType(type),
                payload: data,
                sagaPayload: payload,
            });
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
            }
            handleError(result);
        },
    );
}

function* handleAppCreateAgencyFiles(action: CreateFilesAgencyAction) {
    const {
        payload: { id, files, onSuccess, onError },
    } = action;

    for (let i = 0; i < files.length; i++) {
        if (files[i]?.id || files[i]?.attach || !files[i].type) {
            continue;
        }
        const formData = convertValuesToFormData({ logoDocFile: files[i] }, '');
        yield resolveApiCall(
            action,
            () => AppApi.createAgencyFiles(id, formData),
            function* () {
                yield put(getAgency({ page: 1, itemsPerPage: 1200 }));

                if (onSuccess) {
                    onSuccess();
                }
            },
            function (result: ResolverApiFailure) {
                if (result.error && result.error.response && result.error.response.status) {
                    if (onError) {
                        onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                    }
                }
            },
        );
    }
}

function* handleUpdateAgency(action: UpdateAgencyAction) {
    const { payload } = action;
    const {
        data: { id, ...restData },
        callbacks,
    } = payload;
    const groupAgency: any = groupInfo(restData);
    yield resolveApiCall(
        action,
        () => AppApi.updateAgencyInfo(`${id}`, groupAgency),
        function* () {
            yield call(callbacks.resolve);
        },
        function* (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                yield call(
                    callbacks.reject,
                    result.error instanceof SubmissionError
                        ? result.error
                        : new SubmissionError({
                              _error: result.error.message ?? 'Incorrect response',
                              ...makeFormErrors(result.error.response?.data),
                          }),
                );
            }
            yield handleError(result);
        },
    );
}

export function* handleAgencyInfo(action: GetAgencyAction) {
    const oldData = yield select((state: StoreState) => state.providers.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        AppApi.getAgencyInfo({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}
export default function* () {
    yield takeLatest(AppActions.APP_MOUNT, handleAppMount);
    yield takeLatest(AppActions.CREATE_FILES_AGENCY, handleAppCreateAgencyFiles);
    yield takeLatest(AppActions.APP_FETCH_AGENCY, handleAgencyInfo);
    yield takeLatest(AppActions.APP_FETCH_DASHBOARD, handleFetchDashBoard);
    yield takeLatest(AppActions.APP_UPDATE_AGENCY, handleUpdateAgency);
}
